import React, { createContext, useContext, useState } from 'react';

const RegistrationContext = createContext();

export function RegistrationProvider({ children }) {
  const [registrationData, setRegistrationData] = useState({
    // Personal Details
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    dateOfBirth: '',

    // Address
    address1: '',
    address2: '',
    city: '',
    region: '',
    postcode: '',
    country: 'GB',

    // Membership
    membershipType: '',
    secondMemberFirstName: '',
    secondMemberLastName: '',

    // Payment
    paymentMethod: 'card',
  });

  const updateRegistrationData = newData => {
    setRegistrationData(prev => ({ ...prev, ...newData }));
  };

  return (
    <RegistrationContext.Provider value={{ registrationData, updateRegistrationData }}>
      {children}
    </RegistrationContext.Provider>
  );
}

export function useRegistration() {
  return useContext(RegistrationContext);
}
